export const resumeModalTitle = key => {
  return {
    schedule: 'Todos os Plantões',
    open: 'Plantões Abertos',
    confirmed: 'Plantões Confirmados',
    notConfirmed: 'Plantões Pendentes',
    lack: 'Faltas',
  }[key];
};
